import React, { useCallback } from 'react';
import { FilePdfIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { GAClickButton } from 'utils/analytics';
import { selectPageModelTitle } from 'store/pageModel';
import { Manual, ManualLinkStyles, StyledLink } from './styles';
import { selectAnalizPDFLink } from 'selectors/experiments';

export const AnalizVodyManual = () => {
	const title = useSelector(selectPageModelTitle);
	const PDFLink = useSelector(selectAnalizPDFLink);

	const clickHandler = useCallback(() => {
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: title,
			elementText: 'Инструкция по подготовке воды для анализа',
		});
	}, [title]);

	/** Что бы поменять ссылку на файл - достаточно зайти в FUDZI и поменять ее там https://fudzi.lmru.tech/content/banners/554de519-eff0-4cc9-b26c-40cd48970a96 */

	return (
		<Manual data-qa="analiz-vody-manual">
			<FilePdfIcon type="outline" size="l" color="text-primary" />
			{PDFLink && (
				<Typography variant="m" size="body_accent">
					Ознакомьтесь с{' '}
					<StyledLink
						href={PDFLink}
						target="_blank"
						className={ManualLinkStyles}
						onClick={clickHandler}
					>
						инструкцией по подготовке воды для анализа
					</StyledLink>
				</Typography>
			)}
		</Manual>
	);
};
